{
  "longPressMessage": "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
}
